import { useEffect, useState } from 'react';
/** Does not rely on the host store calling RTK Query setupListeners(). */
export default function usePageVisibility() {
 const [visible, setVisible] = useState(() => typeof document === 'undefined' || document.visibilityState !== 'hidden');
 useEffect(() => {
  const update = () => setVisible(document.visibilityState !== 'hidden');
  document.addEventListener('visibilitychange', update);
  return () => document.removeEventListener('visibilitychange', update);
 }, []);
 return visible;
}
